module.exports = __webpack_public_path__ + "img/excel.a2f5a77d.png";